"use client";

import { useEffect, useState } from "react";
import { searchDrivers } from "@/modules/driver/infraestructure/server/searchDrivers";
import { IOperator } from "@/modules/driver/domain/IOperator";

/** Mínimo de caracteres para pedirle algo al servidor. */
export const MIN_CARACTERES_BUSQUEDA = 2;
/** Cuántos resultados se muestran de entrada. */
export const LIMITE_INICIAL = 20;
/** Cuánto suma cada "Ver más". */
export const PASO_DE_LIMITE = 30;
/**
 * Tope del servidor. El apellido más repetido del padrón son 315 personas, así
 * que con esto se llega a cualquiera sin tener que afinar la búsqueda.
 */
export const LIMITE_MAXIMO = 500;
const DEBOUNCE_MS = 300;

/**
 * Busca operadores con debounce.
 *
 * El debounce no es cosmético: sin él cada tecla dispara una consulta y el
 * enfermero tipea un apellido entero. 300 ms es donde deja de consultar por
 * cada letra sin que se sienta lento.
 */
export function useSearchOperators(termino: string, limite = LIMITE_INICIAL) {
	const [operators, setOperators] = useState<IOperator[]>([]);
	const [total, setTotal] = useState(0);
	const [buscando, setBuscando] = useState(false);
	const [error, setError] = useState(false);

	useEffect(() => {
		const limpio = termino.trim();

		if (limpio.length < MIN_CARACTERES_BUSQUEDA) {
			setOperators([]);
			setTotal(0);
			setBuscando(false);
			setError(false);
			return;
		}

		// Si el enfermero sigue tipeando, la respuesta vieja no tiene que pisar
		// a la nueva.
		let vigente = true;
		setBuscando(true);

		const timer = setTimeout(async () => {
			try {
				const data = await searchDrivers(limpio, limite);
				if (!vigente) return;
				setOperators(data.operators);
				setTotal(data.total);
				setError(false);
			} catch {
				if (!vigente) return;
				setOperators([]);
				setTotal(0);
				setError(true);
			} finally {
				if (vigente) setBuscando(false);
			}
		}, DEBOUNCE_MS);

		return () => {
			vigente = false;
			clearTimeout(timer);
		};
	}, [termino, limite]);

	return { operators, total, buscando, error };
}
